export default "__VITE_ASSET__COulxADj__"